import {Message} from 'view-design'
import cookies from '@/libs/util.cookies.js'
import store from '@/store'
import moment from 'moment'

function calTimeDiff (a, b) {
  return (moment(a).diff(moment(b))) > 0
}

// 处理时间段筛选条件
function handleDateRange (array) {
  let date = {
    start: '',
    end: ''
  }
  if (array && array.constructor === Array && array.length === 2) {
    if (array[0] && array[1]) {
      if (array[0] === array[1]) {
        let day = new Date(array[0])
        day.setHours(0, 0, 0, 0)
        date.start = day.getTime()
        day.setHours(23, 59, 59, 999)
        date.end = day.getTime()
      } else {
        let dayS = new Date(array[0])
        let dayE = new Date(array[1])
        dayS.setHours(0, 0, 0, 0)
        date.start = dayS.getTime()
        dayE.setHours(23, 59, 59, 999)
        date.end = dayE.getTime()
      }
    } else {
      date.start = array[0] || ''
      date.end = array[1] || ''
    }
  } else {
    date.start = ''
    date.end = ''
  }
  return date
}
// 处理日期筛选条件
function handleDate (date) {
  if (date) {
    let day = new Date(date)
    day.setHours(0, 0, 0, 0)
    date = day.getTime()
  } else {
    date = ''
  }
  return date
}
// 处理日期时间筛选条件
function handleDateTime (datetime) {
  if (datetime) {
    let day = new Date(datetime)
    datetime = day.getTime()
  } else {
    datetime = ''
  }
  return datetime
}
// 成功提示
function successTip (message, duration) {
  Message.success({
    content: message,
    duration: duration || 3
  })
}
// 错误提示
function errorTip (e, duration) {
  Message.error({
    content: e,
    duration: duration || 3
  })
}
// 数据请求参数处理
function concatParams (params) {
  params.formparam = true
  return params
}
// 文件上传token
function uploadParams () {
  let UploadParams = {
    Authorization: 'Bearer ' + cookies.get('token')
  }
  return UploadParams
}

function closeTag (name, query) {
  store.commit('closeTag', {name: name, query: query})
}

function isSome (arrry, key, value) {
  let flag = false
  if (arrry.some(a => a[key] === value)) {
    flag = true
  }
  return flag
}
function isFind (arrry, key, value) {
  let obj = null
  let tar = arrry.find(a => a[key] === value)
  if (tar) {
    obj = tar
  }
  return obj
}

export default{
  calTimeDiff,
  handleDateRange,
  handleDate,
  handleDateTime,
  errorTip,
  successTip,
  concatParams,
  uploadParams,
  closeTag,
  isSome,
  isFind
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js